/**
 * Copyright 2026 Ziz Academy
 */

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login: React.FC = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { login, isLoading } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');

        try {
            await login({username, password});
            navigate('/');
        } catch (err: unknown) {
            const errorMessage = err instanceof Error ? err.message : 'Login failed. Please check your credentials.';
            setError(errorMessage);
        }
    };

    return (
        <div className="auth-page" data-testid="login-page">
            <div className="auth-card">
                <span className="auth-emoji">🎓</span>
                <h1 className="auth-title">Welcome Back</h1>
                <p className="auth-subtitle">Let's continue learning together! 🌟</p>

                {error && <div className="alert alert-error" role="alert">{error}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label" htmlFor="username">
                            👤Username
                        </label>
                        <input
                            type="text"
                            id="username"
                            className="form-input"
                            placeholder="Enter your username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            data-testid="username-input"
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label" htmlFor="password">
                            🔒 Password
                        </label>
                        <input
                            type="password"
                            id="password"
                            className="form-input"
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            data-testid="password-input"
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn btn-primary btn-lg"
                        style={{ width: '100%' }}
                        disabled={isLoading}
                        data-testid="login-button"
                    >
                        {isLoading ? '⌛ Logging in...' : '🚀 Let\'s Go!'}
                    </button>
                </form>

                <p style={{ textAlign: 'center', marginTop: '1.5rem', color: '#718096' }}>
                    New here?{' '}
                    <Link to="/register" style={{ color: '#667eea', fontWeight: 'bold' }}>
                        Create an account! 🎉
                    </Link>
                </p>
            </div>
        </div>
    );
};

export default Login;